import { z } from 'zod';

export const ActivePeersSchema = z.object({
  peerIds: z.array(z.string()),
  dominantSpeaker: z.string(),
});

export const RoomControlsSchema = z.object({
  roomLocked: z.boolean(),
  allowProduce: z.boolean(),
  allowProduceSources: z.object({
    cam: z.boolean().default(true),
    mic: z.boolean().default(true),
    screen: z.boolean().default(true),
  }),
  allowConsume: z.boolean(),
  allowSendData: z.boolean(),
});

export const produceSourcesSchema = z.object({
  cam: z.boolean(),
  mic: z.boolean(),
  screen: z.boolean(),
});

export const PermissionSchema = z.object({
  admin: z.boolean(),
  canConsume: z.boolean(),
  canProduce: z.boolean(),
  canProduceSources: produceSourcesSchema,
  canSendData: z.boolean(),
  canRecvData: z.boolean(),
  canUpdateMetadata: z.boolean(),
});

export const VolatileDataMessageSchema = z.object({
  from: z.string(),
  payload: z.unknown(),
  label: z.string().optional(),
  to: z.union([z.literal('*'), z.array(z.string())]).optional(),
});

export const RecordingTypeSchema = z.enum(['recording', 'livestream']);

export const ApiKeyRecordingStatusSchema = z.object({
  status: z.enum(['ongoing', 'stopped']),
  startTime: z.number().optional(),
  type: RecordingTypeSchema.optional(),
});
